import { createFileRoute, notFound } from '@tanstack/react-router';
import { SendMoneyCalculatorPage } from '~/components/sections/SendMoneyCalculatorPage';
import { calculatorPairHeadMeta, getCalculatorPair } from '~/content/calculatorPairs';
import calculatorCss from '~/styles/calculator.css?inline';

export const Route = createFileRoute('/calculator/$pair')({
  loader: ({ params }) => {
    const pair = getCalculatorPair(params.pair);
    if (!pair) throw notFound();
    return { pair };
  },
  head: ({ loaderData }) => {
    const head = calculatorPairHeadMeta(loaderData?.pair);
    return {
      ...head,
      // Inlined (not a linked stylesheet) — calculator.css's descender-clipping
      // override only wins the cascade-layer race when inlined into <head>.
      styles: [...(head.styles ?? []), { children: calculatorCss }],
    };
  },
  component: CalculatorPairPage,
});

function CalculatorPairPage() {
  const { pair } = Route.useLoaderData();
  // Remount when the slug changes so controlled calculator state resets to the
  // pair's target currency (client navigations between calculator SEO pages).
  return (
    <SendMoneyCalculatorPage
      key={pair.slug}
      heroTitle={pair.heroTitle}
      initialTarget={pair.target}
    />
  );
}
